import { observable } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/observable.js?vue3';

export default observable('confidential_mr_state', {
  selectedProject: {},
});
